import { MultiFieldConfig } from '@shared/models/multi-field-config';

export class CropResizeConstraints {
	readonly cropMinWidth: number;
	readonly cropMaxWidth: number;
	readonly cropMinHeight: number;
	readonly cropMaxHeight: number;
	readonly aspectRatio: number;
	readonly maintainAspectRatio: boolean;

	constructor(config?: MultiFieldConfig) {
		this.cropMinWidth = 0;
		this.cropMaxWidth = 0;
		this.cropMinHeight = 0;
		this.cropMaxHeight = 0;
		this.aspectRatio = 1;
		this.maintainAspectRatio = false;

		if (config) {
			if (config.imagewidth && config.imagewidth > 0 && config.propstretch && config.propstretch > 0) {
				this.cropMinWidth = config.imagewidth * 100 / config.propstretch;
			}
			if (config.imagewidth && config.imagewidth > 0 && config.propshrink && config.propshrink > 0) {
				this.cropMaxWidth = config.imagewidth * 100 / config.propshrink;
			}
			if (config.imageheight && config.imageheight > 0 && config.propstretch && config.propstretch > 0) {
				this.cropMinHeight = config.imageheight * 100 / config.propstretch;
			}
			if (config.imageheight && config.imageheight > 0 && config.propshrink && config.propshrink > 0) {
				this.cropMaxHeight = config.imageheight * 100 / config.propshrink;
			}
			if (config.imagewidth && config.imagewidth > 0 && config.imageheight && config.imageheight > 0) {
				this.aspectRatio = config.imagewidth / config.imageheight;
			}
			if ((this.cropMinWidth || this.cropMaxWidth) && (this.cropMinHeight || this.cropMaxHeight)) {
				this.maintainAspectRatio = true;
			}
		}
	}

	get hasMinHWLimits(): boolean {
		return this.cropMinWidth > 0 || this.cropMinHeight > 0;
	}

	get hasMaxHWLimits(): boolean {
		return this.cropMaxWidth > 0 || this.cropMaxHeight > 0;
	}

	isWidthWithinLimits(width: number): boolean {
		let res = true;

		if (this.cropMinWidth > 0 && width < this.cropMinWidth) {
			res = false;
		}

		if (this.cropMaxWidth > 0 && width > this.cropMaxWidth) {
			res = false;
		}

		return res;
	}

	isHightWithinLimits(height: number): boolean {
		let res = true;

		if (this.cropMinHeight > 0 && height < this.cropMinHeight) {
			res = false;
		}

		if (this.cropMaxHeight > 0 && height > this.cropMaxHeight) {
			res = false;
		}

		return res;
	}
}
